import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import EcFilterInput from '~/components/Shared/EcFilterInput/EcFilterInput';
import { Button } from '~/eds/src/components/Button/Button';
import { FormattedMessage, injectIntl } from 'react-intl';
import { sortByStringValue } from '~/utils/array';

import { evisortGreen } from '../../../assets/shared-styles/general';
import { getDocumentsViewsetFields } from '../../DocumentsViewPage/Document.data';
import EcDocumentsVisibleField from '../../Shared/EcDocumentsVisibleField/EcDocumentsVisibleField';
import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import AddIcon from '../../Shared/Icons/AddIcon';
import LoadingSpinner from '../../Shared/Icons/LoadingSpinner';
import styles from './DocumentsColumnFieldsModal.styles';

class DocumentsColumnFieldsModal extends Component {
  constructor(props) {
    super(props);

    this.handleAddRow = this.handleAddRow.bind(this);
    this.handleRemoveRow = this.handleRemoveRow.bind(this);
    this.handleItemReorder = this.handleItemReorder.bind(this);
    this.handleAddAllFields = this.handleAddAllFields.bind(this);
    this.handleOnSaveClick = this.handleOnSaveClick.bind(this);

    this.state = {
      loading: false,
      filtering: false,
      notAddedDocumentColumnFields: [],
      filteredDocumentColumnFields: [],
      filteredNotAddedDocumentColumnFields: [],
    };
  }

  componentDidMount() {
    this.setState({ documentColumnFields: this.props.data });
    getDocumentsViewsetFields().then((data) => {
      const notAddedDocumentColumnFields = data
        .filter(
          (field) =>
            !this.props.data.some((item) => item.field_id === field.field_id),
        )
        .sort(sortByStringValue('field_name'));
      this.setState({ notAddedDocumentColumnFields });
    });
  }

  handleAddRow(field) {
    const {
      documentColumnFields,
      notAddedDocumentColumnFields,
      filteredDocumentColumnFields,
      filteredNotAddedDocumentColumnFields,
    } = this.state;

    const newDocumentColumnFields = [...documentColumnFields, field];
    const newNotAddedDocumentColumnFields = notAddedDocumentColumnFields.filter(
      (item) => item.field_id !== field.field_id,
    );

    const newFilteredDocumentColumnFields = [
      ...filteredDocumentColumnFields,
      field,
    ];
    const newFilteredNotAddedDocumentColumnFields =
      filteredNotAddedDocumentColumnFields.filter(
        (item) => item.field_id !== field.field_id,
      );

    this.setState({
      documentColumnFields: newDocumentColumnFields,
      notAddedDocumentColumnFields: newNotAddedDocumentColumnFields,
      filteredDocumentColumnFields: newFilteredDocumentColumnFields,
      filteredNotAddedDocumentColumnFields:
        newFilteredNotAddedDocumentColumnFields,
    });
  }

  handleRemoveRow(field) {
    const {
      documentColumnFields,
      notAddedDocumentColumnFields,
      filteredDocumentColumnFields,
      filteredNotAddedDocumentColumnFields,
    } = this.state;

    const newDocumentColumnFields = documentColumnFields.filter(
      (item) => item.field_id !== field.field_id,
    );
    const newNotAddedDocumentColumnFields = [
      ...notAddedDocumentColumnFields,
      field,
    ];

    const newFilteredDocumentColumnFields = filteredDocumentColumnFields.filter(
      (item) => item.field_id !== field.field_id,
    );

    this.setState({
      documentColumnFields: newDocumentColumnFields,
      notAddedDocumentColumnFields: newNotAddedDocumentColumnFields,
      filteredDocumentColumnFields: newFilteredDocumentColumnFields,
      filteredNotAddedDocumentColumnFields: [
        ...filteredNotAddedDocumentColumnFields,
        field,
      ],
    });
  }

  handleItemReorder(items) {
    this.setState({ documentColumnFields: items });
  }

  handleAddAllFields() {
    const {
      documentColumnFields,
      filteredDocumentColumnFields,
      notAddedDocumentColumnFields,
      filteredNotAddedDocumentColumnFields,
    } = this.state;

    this.setState({
      documentColumnFields: [
        ...documentColumnFields,
        ...notAddedDocumentColumnFields,
      ],
      notAddedDocumentColumnFields: [],
      filteredDocumentColumnFields: [
        ...filteredDocumentColumnFields,
        ...filteredNotAddedDocumentColumnFields,
      ],
      filteredNotAddedDocumentColumnFields: [],
    });
  }

  handleOnSaveClick() {
    const { handleSaveEditColumns, hideModal } = this.props;
    const { documentColumnFields } = this.state;

    const fields = documentColumnFields.map((field, index) => {
      return {
        column_number: index,
        field_id: field.field_id,
      };
    });

    handleSaveEditColumns(fields);
    hideModal();
  }

  handleFieldSearch(filterValue) {
    const { documentColumnFields, notAddedDocumentColumnFields } = this.state;
    const newDocumentColumnFields = documentColumnFields.filter((field) =>
      field.field_name.toLowerCase().includes(filterValue.toLowerCase()),
    );
    const newNotAddedDocumentColumnFields = notAddedDocumentColumnFields.filter(
      (field) =>
        field.field_name.toLowerCase().includes(filterValue.toLowerCase()),
    );

    this.setState({
      filterValue,
      filtering: true,
      filteredDocumentColumnFields: newDocumentColumnFields,
      filteredNotAddedDocumentColumnFields: newNotAddedDocumentColumnFields,
    });

    if (!filterValue) {
      this.setState({ filtering: false });
    }
  }

  renderSearchBox() {
    const { classes, intl } = this.props;
    const { filterValue } = this.state;

    return (
      <div className={classes.searchboxContainer}>
        <div className={classes.filterSearch}>
          <EcFilterInput
            value={filterValue}
            onChange={(filterValue) => this.handleFieldSearch(filterValue)}
            onClearSearch={() => this.handleFieldSearch('')}
            placeholder={intl.formatMessage({
              id: 'DocumentsColumnFieldsModal.filterPlaceholder',
              defaultMessage: 'Filter fields...',
              description: 'Placeholder text for filter fields input',
            })}
            id="documents-filter-fields-input"
          />
        </div>
      </div>
    );
  }

  renderVisibleColumns() {
    const { documentColumnFields, filtering, filteredDocumentColumnFields } =
      this.state;

    return (
      <div>
        <EcDocumentsVisibleField
          filtering={filtering}
          itemsData={
            filtering ? filteredDocumentColumnFields : documentColumnFields
          }
          handleRemoveRow={this.handleRemoveRow}
          handleItemReorder={this.handleItemReorder}
        />
      </div>
    );
  }

  renderList(list) {
    const { classes, intl } = this.props;
    return list.map((field) => {
      return (
        <div
          className={classes.itemFieldContainer}
          key={`field-${field.field_id}`}
        >
          <span className={classes.fieldName}>{field.field_name}</span>
          <button
            className={classes.itemRowActionButton}
            title={intl.formatMessage(
              {
                id: 'DocumentsColumnFieldsModal.addFieldTitle',
                defaultMessage: 'Add {fieldName} field',
                description:
                  'Button title for adding field. Example: fieldName = "Customer Name"',
              },
              {
                fieldName: field.field_name,
              },
            )}
            onClick={() => this.handleAddRow(field)}
          >
            <AddIcon color={evisortGreen} />
          </button>
        </div>
      );
    });
  }

  renderToAddColumnFields() {
    const { classes } = this.props;
    const {
      notAddedDocumentColumnFields,
      filtering,
      filteredNotAddedDocumentColumnFields,
    } = this.state;

    if (
      !notAddedDocumentColumnFields.length ||
      (filtering && !filteredNotAddedDocumentColumnFields.length)
    )
      return null;
    return (
      <div className={classes.otherFieldsContainer}>
        <div className={classes.headerContainer}>
          <span className={classes.titleContainer}>
            <FormattedMessage
              id="DocumentsColumnFieldsModal.otherFieldsTitle"
              defaultMessage="OTHER FIELDS"
              description="Title for other fields section"
            />
          </span>
          <button
            className={classes.titleActionContainer}
            onClick={this.handleAddAllFields}
          >
            <FormattedMessage
              id="DocumentsColumnFieldsModal.addAllButton"
              defaultMessage="Add All"
              description="Button text to add all fields"
            />
          </button>
        </div>
        <div className={classes.listContainer}>
          {filtering
            ? this.renderList(filteredNotAddedDocumentColumnFields)
            : this.renderList(notAddedDocumentColumnFields)}
        </div>
      </div>
    );
  }

  render() {
    const { classes, hideModal, intl } = this.props;
    const { loading, errorLoading } = this.state;

    if (loading && !errorLoading) {
      return (
        <div className={classes.loadingContainer}>
          <LoadingSpinner size="medium" />
        </div>
      );
    } else if (!loading && errorLoading) {
      return (
        <div className={classes.errorMessage}>
          <FormattedMessage
            id="DocumentsColumnFieldsModal.loadError"
            defaultMessage="An error occurred while loading the document fields."
            description="Error message when loading document fields fails"
          />
        </div>
      );
    }
    return (
      <EcModalCard
        title={intl.formatMessage({
          id: 'DocumentsColumnFieldsModal.title',
          defaultMessage: 'View Settings',
          description: 'Title for view settings modal',
        })}
        content={
          <div className={classes.modalBody}>
            <div className={classes.modalBodyContent}>
              {this.renderSearchBox()}
              {this.renderVisibleColumns()}
              {this.renderToAddColumnFields()}
            </div>
          </div>
        }
        footer={
          <>
            <Button
              variant="tertiary"
              text={intl.formatMessage({
                id: 'DocumentsColumnFieldsModal.cancelButton',
                defaultMessage: 'Cancel',
                description: 'Cancel button text',
              })}
              onClick={hideModal}
            />
            <Button
              variant="primary"
              text={intl.formatMessage({
                id: 'DocumentsColumnFieldsModal.applyButton',
                defaultMessage: 'Apply',
                description: 'Apply button text',
              })}
              onClick={this.handleOnSaveClick}
            />
          </>
        }
        hideModal={hideModal}
      />
    );
  }
}

DocumentsColumnFieldsModal.propTypes = {
  handleSaveEditColumns: PropTypes.func.isRequired,
  hideModal: PropTypes.func,
};

export default injectIntl(injectSheet(styles)(DocumentsColumnFieldsModal));
